import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'degrees'})
export class DegreesPipe implements PipeTransform {
  transform(value: number): string {
    return (typeof value === 'undefined' || value === null) ? '' : value + '℃';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/degrees.pipe.ts